<ng-template #iconWarn>
  <i class="ico-cancel light-color-warning"></i>
</ng-template>
<ng-template #noFeatureInfo>
  <div class="pnl-feature">
    <i class="ico-exclaim-1 light-color-info"></i>
    <span i18n="@@pnlInformationUnavailable">Information unavailable</span>
  </div>
</ng-template>
@if (
  {
    results: (searchParams.results | async) || [],
    isvalid: searchParams.isValid | async,
    messages: (searchParams.messages | async) || []
  };
  as data
) {
  <h2 class="visuallyhidden" i18n="@@fastTrack_searchCriteria">Search Criteria</h2>
  <div class="background-container-background">
    <app-validate-errors [messages]="data.messages"></app-validate-errors>
    <a href="#parking" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
      >Skip to Result Content</a
    >
    <app-invoked-user></app-invoked-user>
    <app-search-toggle [serviceType]="ServiceType.FastTrack">
      <app-fast-track-search></app-fast-track-search>
      <div class="flex-row-container flex-row-container--right">
        <button
          type="button"
          (click)="performSearch()"
          [disabled]="!data.isvalid"
          appButton="large-search"
          type="button"
          i18n="@@fastTrackSearch"
        >
          Search
        </button>
      </div>
    </app-search-toggle>
  </div>
  @if (!searchService.search_loading) {
    <app-risk-alerts [countryCode]="searchParams.locationCode?.countryCode"></app-risk-alerts>
  }
  <app-fast-track-loading-screen [animated]="false"></app-fast-track-loading-screen>
  @if (flightSearchParams.fasttrackFromFlightSearchPerformed) {
    <button
      appButton="small"
      class="back-to-button"
      routerLink="/results/flights"
      i18n="@@backToFlightsTrainlineEu"
      id="fasttrack-button-back-to-flights"
    >
      <i class="ico-flight" aria-hidden="true"></i>
      Back to Flights
    </button>
  }
  @if (!mapView) {
    <div id="parking" class="pnl-results-container results-width">
      @if (data.results && data.results.length === 0) {
        <app-no-results></app-no-results>
      }
      <ul class="fasttrack-list">
        @for (item of data?.results | loungesPriceSort; track item; let i = $index) {
          <li
            class="pnl-item"
            role="group"
            [attr.aria-label]="'Parking option ' + (index + 1) + ': ' + item.name"
          >
            <div class="flex-row-container flex-row-container--between">
              <div class="pnl-desc">
                <h3>{{ item?.name }} <span i18n="@@fastTrackName"> - Fast Track</span></h3>
              </div>
              <button
                (click)="toggleItemPhotos(item.images)"
                attr.aria-label="Show photos for {{ item.name }}"
                class="light-btn light-btn-ico light-btn-primary"
              >
                <app-photos-icon></app-photos-icon>
              </button>
            </div>
            @if (item.logo || item.images.length > 0) {
              <div class="pnl-image">
                <img
                  [src]="item.logo ? (item.logo | removeSpaces) : (item.images[0] | removeSpaces)"
                  alt="{{ item.name }} logo"
                />
              </div>
            }
            <app-preferred-icons
              [tmcPreferred]="item.tmcPreferred"
              [tmcPreferredLogoUrl]="item.tmcPreferredLogoUrl"
              [tmcPreferredMessage]="item.tmcPreferredMessage"
              [clientPreferred]="item.officePreferred || item.companyPreferred"
              [companyPreferredMessage]="item.companyPreferredMessage"
              [officePreferredMessage]="item.officePreferredMessage"
            >
            </app-preferred-icons>
            <div class="pnl-actions">
              <div class="fasttrack_results_rate">
                <span class="daily_rate">
                  <span id="daily_rate_{{ index }}"> {{ item.price | number: '1.2-2' }} </span>
                  <em>{{ item.currency }}</em>
                </span>
                <span class="rate_plan" i18n="@@totalPrice"> Total Price </span>
                <app-warning-tags [iconId]="j" [ticket]="item"></app-warning-tags>
              </div>
              <div class="flex-column-container fasttrack-buttons-wrapper">
                <button
                  [disabled]="item.unavailable && !canOverride"
                  (click)="addToCart(item)"
                  appButton="small"
                  id="fasttrack-add-to-basket-{{ i }}"
                  attr.aria-label="{{
                    item.price | currency: item.currency || 'GBP'
                  }} add to cart {{ item.name }}"
                >
                  @if (!displayItinerary) {
                    <span i18n="@@pnlAddToCart">Add to basket</span>
                  }
                  @if (displayItinerary) {
                    <span i18n="@@pnlAddToItinerary">Add to itinerary</span>
                  }
                </button>
                <button
                  (click)="openFasttrackDetails(item)"
                  appButton="small"
                  id="parking-add-to-basket-{{ index }}"
                  attr.aria-label="Additional details for {{
                    item?.price | currency: item.currency || 'GBP'
                  }} {{ item.name }}"
                >
                  <span i18n="@@pnlAdditionalDetails">Additional Details</span>
                </button>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  }
  @if (mapView) {
    <app-map-view [item]="selectedItem" (closeMapView)="onCloseMapView()"></app-map-view>
  }
}
